import { TRIGGER_META_EVENT_URL } from "~/constants";
import { BaseError, FetchError, MetaPixelError } from "~/errors";
import { ActionTypeEnum } from "~/types";
import { err, ok, Result } from "neverthrow";

import { safeJsonStringify } from "./safe-json-stringify";

export function triggerMetaEvent(
  key: string,
  eventName: string,
  isCustomEvent: boolean = false,
): Result<undefined, BaseError> {
  const stringifiedDataResult = safeJsonStringify({
    type: ActionTypeEnum.META_EVENT,
    key,
    eventName,
    eventSourceUrl: window.location.href,
  });

  if (stringifiedDataResult.isErr()) {
    return err(stringifiedDataResult.error);
  }

  const blob = new Blob([stringifiedDataResult.value], {
    type: "application/json",
  });

  try {
    const success = navigator.sendBeacon(TRIGGER_META_EVENT_URL, blob);

    if (!success) {
      return err(new FetchError(`Failed to queue request.`));
    }

    if (!(window as any).fbq) {
      return err(new MetaPixelError("Meta Pixel is not available."));
    }

    if (isCustomEvent) {
      (window as any).fbq("trackCustom", eventName);
    } else {
      (window as any).fbq("track", eventName);
    }

    return ok(undefined);
  } catch (error: unknown) {
    return error instanceof Error
      ? err(new FetchError(error.message))
      : err(new FetchError());
  }
}
